package org.teddapp.project.resources

/** Un fichier choisi sur l'appareil : son nom et ses octets. */
class PickedFile(val name: String, val bytes: ByteArray)

/**
 * Sélecteur de fichiers, fourni par la plateforme qui en a un (bureau, Android). Reçoit
 * les extensions proposées, rend le fichier choisi, ou null si l'on a annulé. Absent,
 * l'écran des ressources ne propose que les liens et les textes.
 */
object TeddFilePicker {
    var pick: (suspend (extensions: List<String>) -> PickedFile?)? = null
}
